import { render, staticRenderFns } from "./TalentCard.vue?vue&type=template&id=6ad56f40&scoped=true&"
import script from "./TalentCard.vue?vue&type=script&lang=js&"
export * from "./TalentCard.vue?vue&type=script&lang=js&"
import style0 from "./TalentCard.vue?vue&type=style&index=0&id=6ad56f40&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ad56f40",
  null
  
)

export default component.exports